(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('skeletonButton', {
            templateUrl: 'app/components/skeleton/button/skeleton-button.html',
            controller: skeletonButtonController,
            bindings: {
                label: '@',
                buttonClass: '@?'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function skeletonButtonController() {
        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.label = vm.label || Math.random().toString(36).substring(10);
            vm.buttonClass = vm.buttonClass || 'btn btn-primary';
        }
    }
})();
